import Component from '../core/Component'
import enquire from 'enquire.js'
import { queries } from '../core/config'
import { enableScrolling, disableScrolling } from '../services/Viewport/scroll'

const STATES = {
    ACTIVE: 'is-active'
}

export default class Nav extends Component {
    constructor(element) {
        super(element)

        this.enquireHandler = {
            match: () => {
                if (this.is(STATES.ACTIVE)) {
                    this.close()
                }
            }
        }
    }

    prepare() {
        enquire.register(queries.mediumUp, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(queries.mediumUp, this.enquireHandler)
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        disableScrolling()
        this.element.classList.add(STATES.ACTIVE)
        this.emit('open')
    }

    close() {
        enableScrolling()
        this.element.classList.remove(STATES.ACTIVE)
        this.emit('close')
    }
}